// extracted by mini-css-extract-plugin
export default {"signin_signup_container":"form_signin_signup_container__Du-06","github_button":"form_github_button__SLj+J","form_input_container":"form_form_input_container__1bIiq"};